import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelSettingsGroupsResolverErrorStatesEnum {
    GetGroupsFailed = ErrorStateScheduleEnum.PanelSettingsGroupsResolverStatesStartIndex
}
